module.exports = __webpack_public_path__ + "img/menu-item-3.cdf43511.svg";